import { render, staticRenderFns } from "./ReceiveDetails.vue?vue&type=template&id=3163076e&"
import script from "./ReceiveDetails.vue?vue&type=script&lang=js&"
export * from "./ReceiveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports